import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteBusMaintenanceStay } from '../../../../actions/mechanical-maintenance/BusMaintenanceStay';

const BusMaintenanceStayDeleteButton = ({
  dispatchDeleteBusMaintenanceStay,
  busMaintenanceStayId,
  disabled,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onClickDelete = () =>
    dispatchDeleteBusMaintenanceStay({ busMaintenanceStayId });

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  return (
    <>
      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDelete}
        onClickCancel={closeModal}
      />
      <Button color="danger" onClick={openModal} disabled={disabled}>
        <i className="fa fa-trash-o" /> Eliminar
      </Button>
    </>
  );
};

BusMaintenanceStayDeleteButton.propTypes = {
  dispatchDeleteBusMaintenanceStay: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  busMaintenanceStayId: PropTypes.number.isRequired,
};

BusMaintenanceStayDeleteButton.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  dispatchDeleteBusMaintenanceStay: deleteBusMaintenanceStay,
};

export default connect(
  null,
  mapDispatchToProps,
)(BusMaintenanceStayDeleteButton);
